module.exports = __webpack_public_path__ + "img/svg/bitcoin-stats.b6307235ec176ff7bc3953be867312e4.svg";